import { __makeTemplateObject } from './../external/tslib/tslib.es6.js';
import { css } from 'styled-components';

var focusContainer = function (_a) {
    var _b = _a === void 0 ? {} : _a, inset = _b.inset, within = _b.within;
    return function () {
        var code = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            code[_i] = arguments[_i];
        }
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      &:focus", " {\n        outline: transparent;\n        box-shadow: ", ";\n        ", "\n      }\n    "], ["\n      &:focus", " {\n        outline: transparent;\n        box-shadow: ", ";\n        ", "\n      }\n    "])), within && '-within', function (_a) {
            var theme = _a.theme;
            return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            ", "\n          "], ["\n            ", "\n          "])), inset
                ? "inset 0 0 0 2px ".concat(theme.olist.color.neutral.strong)
                : "0 0 0 1px ".concat(theme.olist.color.neutral.softest, ", 0 0 0 3px ").concat(theme.olist.color.neutral.strong));
        }, css.apply(void 0, code));
    };
};
var templateObject_1, templateObject_2;

export { focusContainer };
